import { deps_are_same_default } from './chunk-5D2Q75W2.mjs';
import { useRef } from 'react';

var useCreation = (factory, deps) => {
  const { current } = useRef({
    deps,
    // SAFETY: obj is a placeholder until the first render runs factory(); the initialized flag guards every read.
    obj: void 0,
    initialized: false
  });
  if (!current.initialized || !deps_are_same_default(current.deps, deps)) {
    current.deps = deps;
    current.obj = factory();
    current.initialized = true;
  }
  return current.obj;
};
var use_creation_default = useCreation;

export { use_creation_default };
